<template>
    <tr>
        <td>
            <a :href="'/team/assets/' + product.asset_id + '/edit'" class="title" target="_blank">{{ product.asset_name }}</a>
            <div>
                <span v-if="product.dynamic_pricing" class="icon icon-dynamic-pricing"></span>
                <span v-if="product.restock" class="icon-auto-restock icon"></span>
            </div>
        </td>
        <td>{{ product.category }}</td>
        <td>
            <div class="table-number">
                {{ product.online_price | money }}
            </div>
        </td>
        <td>
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text">$</span>
                </div>
                <input
                    :disabled="form.busy"
                    :readonly="!product.editable"
                    class="form-control table-input"
                    type="number"
                    v-model.number.lazy="form.base_price"
                />
            </div>
            <div class="row d-flex justify-content-between my-1 small" v-if="priceModifier && priceModifier.modifier != 0">
                <div class="col nowrap">Dynamic Pricing:</div>
                <div class="col text-right">{{ priceModifier.modifier > 0 ? '+' : '' }}{{ priceModifier.modifier }}%</div>
            </div>
            <div class="row d-flex justify-content-between my-1 small">
                <div class="col nowrap">Posted Price:</div>
                <div class="col text-right">{{ price | money }}</div>
            </div>
            <div class="help-block invalid-feedback" v-show="form.errors.has('base_price')">
                {{ form.errors.get('base_price') }}
            </div>
        </td>
        <td>
            <div class="table-number">
                <strong>{{ product.units_available_remaining }}</strong>
            </div>
        </td>
        <td>
            <div class="table-number">
                <strong>{{ product.units_sold }}</strong>
            </div>
        </td>
        <td>
            <input
                :disabled="form.busy"
                :readonly="!product.editable"
                class="form-control table-input"
                type="number"
                v-model.number.lazy="form.units_posted_remaining"
            />
            <small class="help-block invalid-feedback" v-show="form.errors.has('units_posted_remaining')">
                {{ form.errors.get('units_posted_remaining') }}
            </small>
        </td>
        <td>
            <div class="dropdown text-center">
                <a href="#" class="text-dark btn btn-plain" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <i class="fal fa-2x fa-ellipsis-v"></i>
                </a>
                <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
                    <a :href="'/team/assets/' + product.asset_id + '/edit'" class="dropdown-item" target="_blank">Edit Asset</a>
                    <a :href="'/team/assets/' + product.asset_id" class="dropdown-item" target="_blank">Preview Asset</a>
                </div>
            </div>
        </td>
    </tr>
</template>

<script>
export default {
    props: {
        product: {
            required: true,
        },
        day: {
            required: true,
        },
    },
    data() {
        return {
            yield: 0,
            price: 0,
            priceModifier: 0,
            watchPrice: true,
            form: new SparkForm({
                base_price: this.product.base_price,
                units_posted_remaining: this.product.units_posted_remaining,
            }),
        };
    },
    created() {
        this.priceModifier = _.get(this.day, 'price_modifier');
        this.setState(this.product);
        this.$watch('form.base_price', (oldVal, newVal) => {
            this.updateValue('base_price', oldVal, newVal);
        });
        this.$watch('form.units_posted_remaining', (oldVal, newVal) => {
            this.updateValue('units_posted_remaining', oldVal, newVal);
        });
    },
    methods: {
        setState(state) {
            this.yield = state.potential_yield;
            this.price = state.price;
        },
        updateValue(attr, newVal, oldVal) {
            const self = this;
            if (this.watchPrice) {
                swalc('Are you sure?', (confirm) => {
                    if (confirm) {
                        Spark.put('/api/team/products/' + this.product.id, this.form).then((response) => {
                            let data = response.data;
                            let newYield = _.get(data, 'potential_yield', 0);
                            Bus.$emit('listViewYieldChange', {
                                day_id: self.day.id,
                                change: newYield - self.yield,
                            });
                            self.setState(data);
                        });
                    } else {
                        self.watchPrice = false;
                        self.$nextTick(() => {
                            self.form[attr] = oldVal;
                            self.$nextTick(() => {
                                self.watchPrice = true;
                            });
                        });
                    }
                });
            }
        },
    },
};
</script>
